module.exports = __webpack_public_path__ + "static/fonts/ProximaNovaT-Thin.6c1411c8.woff";